export const COPYRIGHT_WITH_LINKS = 'copyright-with-links';
